import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faGreaterThan,
  faHandSparkles,
  faLessThan,
} from "@fortawesome/free-solid-svg-icons";
import { fetchQuestionList, postUserChoice } from "../../ServerCall";
import { GlobalContext } from "../../GlobalProvider";
import { toast } from "react-toastify";
import { toastObj } from "../../utils/commanFunctions";
import { FaCheck } from "react-icons/fa";

const Stepper = ({ handleModel, nav }) => {
  const {setEventData,setPlaceData,setFilter} = useContext(GlobalContext)
  useEffect(() => {
    if (nav === "List" || nav==="Map") {
      (async () => {
        let data = await fetchQuestionList();
        if (data.status) setSteps(data.data);
      })();
    }
  }, [nav]);

  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [selection, setSelection] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSelection = (data, ele) => {
    const { id, max_selection = 1, min_selection = 1 } = data;
    const updatedSelection = { ...selection };

    if (updatedSelection[id]) {
      const index = updatedSelection[id]["selected_options"].indexOf(ele);

      if (index !== -1) {
        updatedSelection[id]["selected_options"].splice(index, 1);
      } else {
        if (updatedSelection[id]["selected_options"].length >= max_selection)
         {
          toast.warn("Oops, you can select a maximum of "+max_selection,toastObj);
          return;
         }
        updatedSelection[id]["selected_options"].push(ele);
      }
    } else {
      updatedSelection[id] = {
        question: data.text,
        selected_options: [ele],
      };
    }

    setSelection(updatedSelection);
  };
  const handleComplete = async () => {
    setLoading(true)
    let data = Object.values(selection);
    console.log(data);
    let res = await postUserChoice(data, handleModel, setComplete, setCurrentStep, setSelection,setLoading);
    if (res.status) {
      console.log(res);
      let events = [];
      let places = [];
      let allPlaceAndEvent = []
      for (let i of res.data) {
        if (i.type === "PLACE") {
          places.push(i);
        } else if (i.type === "EVENT") {
          events.push(i);
        }
        allPlaceAndEvent.push(i)
      }
      setPlaceData(places)
      setEventData(events)
      let appData = localStorage.getItem("appData");
      if (appData) {
        appData = JSON.parse(appData); 
        appData = {
          ...appData,
          places,
          events,
          allPlaceAndEvent
        };
        localStorage.setItem("appData", JSON.stringify(appData)); 
      } else {
        let data = {};
        data.places = places;
        data.events = events;
        data.allPlaceAndEvent = allPlaceAndEvent
        localStorage.setItem("appData", JSON.stringify(data)); 
      }

      setFilter("Personalized")
      localStorage.setItem("filter","Personalized")
      if(localStorage.getItem('preservedData'))
      localStorage.removeItem("preservedData")
      toast.success("Choices are saved successfully",toastObj);
    } else {
      console.log(res);
      toast.error("Something went wrong please try again",toastObj);
      
    }
  };
  
  return (
    <>
      {steps.length > 0 ? (
        <div className="mbody">

          <div className="stepper p-6 flex justify-center w-[100%] gap-3 md:gap-0">
            {/* {steps.map((step, i) => (
              <div
                key={i}
                className={`step-item  ${currentStep === i + 1 && "active"} ${
                  (i + 1 < currentStep || complete) && "complete"
                }`}
              >
                <div className="step">
                  {i + 1 < currentStep || complete ? (
                    <FontAwesomeIcon size={24} icon={faCheckCircle} />
                  ) : (
                    i + 1
                  )}
                </div>
               
              </div>
            ))} */}

{steps.map((step, i) => (
              <div
                key={i}
                className={`step-item  ${currentStep === i + 1 && "active"} ${
                  (i + 1 <= currentStep || complete)? "bg-green-500":"bg-slate-300"
                } h-[3px]`}
              style={{
                width:`${(100/steps.length).toString()}%`
              }}
              >
              </div>
            ))}
          </div>
          {/* <p className="text-left text-sm">step 1 of 4</p>   */}
          <div className="">
    <p className="text-center text-3xl font-medium p-4">Are you ready to explore nearby restaurants and things to do</p>
   </div>
          <div className="question p-3 text-center ml-2">
            <p className="text-xl font-bold">{steps[currentStep - 1]["text"]}</p>
            <p className="text-sm text-gray-400">
              Choose Min {steps[currentStep - 1]["min_selection"]} and Max{" "}
              {steps[currentStep - 1]["max_selection"]}
            </p>
          </div>
       

          <div className=" p-4 flex gap-[15px] flex-wrap justify-center overflow-y-scroll max-h-[35vh] lg:w-[60%] md:w-[80%] w-[90%] m-auto">
            {steps[currentStep - 1]?.options &&
              steps[currentStep - 1]?.options.map((e) => (
                // <div
                  // key={e}
                  // onClick={() => handleSelection(steps[currentStep - 1], e)}
                //   className={` ${
                //     selection[
                //       steps[currentStep - 1]["id"]
                //     ]?.selected_options?.includes(e)
                //       ? "border "
                //       : "bg-gray-200"
                //   } 
               
                //   flex cursor-pointer items-center whitespace-nowrap space-x-2 px-3 py-1 font-medium m-1 md:space-x-4 md:px-5 md:py-1.5 md:m-1.5 rounded-full text-sm leading-[24px]`}
                // >
                //     {
                //     !selection[
                //       steps[currentStep - 1]["id"]
                //     ]?.selected_options?.includes(e)
                //       &&  <FaCheck />
                //    }   {e}
                // </div>


                // secnd Latest///////
              //   <div
              //   key={e}
              //   onClick={() => handleSelection(steps[currentStep - 1], e)}
              //   class={`relative grid select-none items-center whitespace-nowrap rounded-lg border   ${selection[steps[currentStep - 1]["id"]]?.selected_options?.includes(e)
              //         ? "border-green-600"
              //         : "border-gray-400"} py-1.5 px-3 text-xs font-bold uppercase`}>
              //   <div class="absolute top-2/4 left-1.5 h-5 w-5 -translate-y-2/4">
               
              //     {  selection[
              //         steps[currentStep - 1]["id"]
              //       ]?.selected_options?.includes(e)
              //         &&  <FaCheck className="m-1" color="green"/>
              //     } 
               
              //   </div>
              //   <span class={`${ selection[
              //         steps[currentStep - 1]["id"]
              //       ]?.selected_options?.includes(e)
              //         ? "ml-[18px] "
              //         : ""}`}>{e}</span>
              // </div>

              // ?????end??????????????

            //   <div
              // key={e}
              // onClick={() => handleSelection(steps[currentStep - 1], e)}
            //   class={`relative grid select-none items-center whitespace-nowrap rounded-lg border   ${selection[steps[currentStep - 1]["id"]]?.selected_options?.includes(e)
            //         ? "border-green-600"
            //         : "border-gray-400"} py-1.5 px-3 text-xs font-bold uppercase`}>
            
            //   <span class={`${ selection[
            //         steps[currentStep - 1]["id"]
            //       ]?.selected_options?.includes(e)
            //         ? "ml-[18px] "
            //         : ""}`}>{e}</span>
            // </div>
            <div class="flex items-center"
            key={e}
            onClick={() => handleSelection(steps[currentStep - 1], e)}
            >
            <input id={e} type="radio" name={e} value={e} class="h-4 w-4 border-gray-300" aria-labelledby={e} aria-describedby={e} checked={selection[
                    steps[currentStep - 1]["id"]
                  ]?.selected_options?.includes(e)} />
            <label for={e} class="text-sm font-medium text-gray-900 ml-2 block">
           {e}
            </label>
          </div>


              ))}
          </div>
 <div className="flex justify-center items-center m-5 gap-2">
 <div
            className={`back ${
              currentStep === 1 && "hidden"
            } rounded-xl`}
          >
            <button
              onClick={() => {
                setComplete(false);
                setCurrentStep((prev) => prev - 1);
              }}
              className="flex py-2 px-4 items-center items-center text-white border rounded-lg"
              style={{
                background:localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808",
                 
              }}
            >
              {/* rounded-xl */}
              {/* <FontAwesomeIcon
                className="text-dark-200 pl-2"
                icon={faLessThan}
              /> */}
              <p className="text-dark-200 pl-2">Back</p>
            </button>
          </div>
 <div
            className={`${
              selection[steps[currentStep - 1]?.id]?.selected_options?.length >=
                steps[currentStep - 1]?.min_selection &&
              selection[steps[currentStep - 1]?.id]?.selected_options?.length <=
                steps[currentStep - 1]?.max_selection
                ? ""
                : "hidden"
            } continue`}
          >
            <button
              onClick={() => {
                currentStep === steps.length
                  ? handleComplete()
                  : setCurrentStep((prev) => prev + 1);
              }}
              className={`flex p-2 px-4 border rounded-lg  items-center text-white ${loading?"bg-white-800":""}`}
              style={{
                background:localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808",
                 
              }}
              // rounded-xl
            >
         {/* {
          !loading &&      <FontAwesomeIcon
          className="text-white px-2"
          icon={faHandSparkles}
        />
         } */}
      {!loading?(currentStep === steps.length ? "Finish" : "Continue"):(
                <p className="" style={{color:"green"}}>
                {" "}
                <div
            class="inline-block h-5 w-5 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-success motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status">
            <span
              class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
              >Loading...</span
            >
          </div>
              </p>
      )}
        {/* {!loading &&       <FontAwesomeIcon
                className="text-white pl-2"
                icon={faGreaterThan}
              />} */}
            </button>
          </div>
       
 </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-[70vh]">
          <p className="text-sm text-gray-400 text-center">Loading...</p>
        </div>
      )}
    </>
  );
};

export default Stepper;
